/** @jsxImportSource @emotion/react */

import { WORK_STATUS_ORDER, type WorkStatus } from '@kaiizen/kai-scan-template-system';

import { DEFAULT_TASK_STATUS_BADGE_STYLES, TASK_STATUS_BADGE_LABEL } from '@/Client/Widgets/TaskStatusBadge';

import {
  PROGRESS_UPDATE_STATUS_CURRENT_DOT_STYLE,
  PROGRESS_UPDATE_STATUS_GRID_STYLE,
  PROGRESS_UPDATE_STATUS_OPTION_SELECTED_STYLE,
  PROGRESS_UPDATE_STATUS_OPTION_STYLE,
} from './focusedProgressUpdateModalStyles';

export const ProgressUpdateStatusGrid = ({
  selectedStatus,
  currentStatus,
  onSelectStatus,
}: {
  selectedStatus?: WorkStatus;
  currentStatus?: WorkStatus;
  onSelectStatus: (status: WorkStatus) => void;
}) => (
  <div css={PROGRESS_UPDATE_STATUS_GRID_STYLE} role='listbox' aria-label='Work status'>
    {WORK_STATUS_ORDER.map(status => {
      const isSelected = selectedStatus === status;
      const isCurrent = currentStatus === status;
      const { Icon, tone } = DEFAULT_TASK_STATUS_BADGE_STYLES.statusStyles[status];

      return (
        <button
          key={status}
          type={'button'}
          role={'option'}
          aria-selected={isSelected}
          title={isCurrent ? 'Current status' : undefined}
          css={[
            PROGRESS_UPDATE_STATUS_OPTION_STYLE,
            isSelected && PROGRESS_UPDATE_STATUS_OPTION_SELECTED_STYLE,
          ]}
          style={isSelected ? tone : undefined}
          onClick={() => onSelectStatus(status)}
        >
          {Icon && <Icon color={tone.color} size={12} aria-hidden />}
          {TASK_STATUS_BADGE_LABEL[status]}
          {isCurrent ? <span css={PROGRESS_UPDATE_STATUS_CURRENT_DOT_STYLE} aria-hidden /> : null}
        </button>
      );
    })}
  </div>
);
